import React from "react";
import { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import Loading from './Loading';
import ResourceLibraryEdit from "./ResourceLibraryEdit";
import { useLocation,useNavigate,useSearchParams,useParams } from 'react-router-dom';
import { configData } from "../config";

const ResourceLibraryView = ({ savedData }) => {

    const [isLoading, setIsLoading] = useState(true);
    const [detailedview, setDetailedView] = useState({});
    const {rid} = useParams();
    const app_url = configData.APP_URL;
const location  = useLocation();
   const successMessage = location.state?.message; // Access the message
   window.history.replaceState({}, '');
    const getFileIcon = (fileName) => {
        const extension = fileName.split('.').pop().toLowerCase();

        switch (extension) {
            case 'txt':
            return '/basic/web/images/text-plain.png';
            case 'pdf':
            return '/basic/web/images/application-pdf.png';
            case 'docx':
            return '/basic/web/images/x-office-document.png';
            case 'jpg':
            case 'jpeg':
            return '/basic/web/images/image-x-generic.png';
            case 'xls':
            case 'xlsx':
            return '/basic/web/images/x-office-spreadsheet.png';
            case 'csv':
            return '/basic/web/images/text-x-generic.png';
            case 'mp4':
            return '/basic/web/images/video-x-generic.png';
            case 'png':
            return '/basic/web/images/image-x-generic.png';
            default:
            return '/basic/web/images/image-x-generic.png';
        }
    };

    useEffect(() => {
             Promise.all([
              retrieveresourcelibrary()
              ]).then(() => {
         
                setIsLoading(false);
               
              })
           
         
        },[]);
     async function  retrieveresourcelibrary() {
            const response = await fetch(
            app_url+'smwwagency/retrieveresourcelibrary?id='+rid,
                {
                    method: "GET",
            
                    headers: {
                    'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data.msg == "Success") {
                setDetailedView(
                    {
                    title: responsedata.data.result.title,
                       body: responsedata.data.result.body,
                       field_folder: responsedata.data.result.field_folder,
                       field_folder_id: responsedata.data.result.field_folder_id,
                       field_url:responsedata.data.result.field_url,
                       field_meta_title:responsedata.data.result.field_meta_title,
                       field_meta_keywords:responsedata.data.result.field_meta_keywords,
                      field_meta_description:responsedata.data.result.field_meta_description,
                      field_file_attachments:responsedata.data.result.field_file_attachments
                    }
                );
               console.log(detailedview);
               
    
            }
        }
        const redirectToFolderPage = () => {
            window.location.href = '/resource_library?tid='+detailedview.field_folder_id;
        };

    return (
        <>
            {isLoading ? (
                <Loading />
            ) : ( 
                <div>
                        {successMessage && (
                        <div className="set-message-done">
                          <span className="cart-message-icon message-icon"><i className="fa fa-check-circle"></i></span> {successMessage}
                        </div>
                        )}
         
                    <h1 className="edit-task-title"> {detailedview.title}</h1>
                    <div>
                        <h2 className="email-title">
                            {/* <strong>Body:</strong> */}
                        </h2>

                        <div
                            dangerouslySetInnerHTML={{
                            __html: detailedview.body || '',
                            }}
                        />
                        <div className="email-meta">
                            {detailedview.field_folder && (
                                // <p><strong>Folder:</strong> {detailedview.field_folder}</p>
                                <p><strong>Folder:</strong> <a href onClick={redirectToFolderPage} style={{cursor: "pointer"}}>{detailedview.field_folder}</a></p>
                            )}
                            {detailedview.field_url && (
                                // <p><strong>URL:</strong> {detailedview.field_url}</p>
                                <p><strong>URL:</strong> <a href={detailedview.field_url} target="_blank">{detailedview.field_url}</a></p>
                            )}
                            {detailedview.field_file_attachments && detailedview.field_file_attachments.length > 0 && (
                                <>
                                    <strong>File Attachments:</strong>
                                    <ul style={{paddingLeft: "0px"}}>
                                    {detailedview.field_file_attachments.map((file, idx) => (
                                        <li key={idx}>
                                            <span className="file">
                                                <img
                                                    className="file-icon"
                                                    alt="File icon"
                                                    src={getFileIcon(file.name)}
                                                    style={{ marginRight: '8px' }}
                                                />
                                                <a href={file.url} target="_blank" rel="noreferrer">
                                                {file.name}
                                                </a>
                                            </span>
                                            ({(file.size / 1024).toFixed(2)} KB)
                                        </li>
                                    ))}
                                    </ul>
                                </>
                            )}
                            {detailedview.field_meta_title && (
                                <p><strong>Meta Title:</strong> {detailedview.field_meta_title}</p>
                            )}
                            {detailedview.field_meta_keywords && (
                                <p><strong>Meta Keywords:</strong> {detailedview.field_meta_keywords}</p>
                            )}
                            {detailedview.field_meta_description && (
                                <p><strong>Meta Description:</strong> {detailedview.field_meta_description}</p>
                            )}
                        </div>
                    </div>  
                </div>
            )}
        </>
    );
};
export default ResourceLibraryView;